
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getBaseUrl } from "../api";
import "../Styles/Login.css";
import Header from "./Header";

function Signup() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [contact, setContact] = useState("");
  const [crn, setCrn] = useState(null);
  const [error, setError] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpTimer, setOtpTimer] = useState(30);
  const [isCounting, setIsCounting] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const baseUrl = getBaseUrl();
  const validateEmail = (email) => {
    const gmailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
    return gmailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    if (emailValue === "") {
      setIsEmailValid(false);
    } else {
      const isValid = validateEmail(emailValue);
      setIsEmailValid(isValid);
    }
    setOtpSent(false);
  };

  const checkEmailExists = async () => {
    try {
      const response = await axios.post(`https://${baseUrl}/request`, {
        object: "users",
        action: "R",
        email: email,
      });
      if (response.data && response.data.status === "00") {
        return true; // Email already exists
      }
      return false;
    } catch (err) {
      console.error("Email check error:", err);
      return false;
    }
  };

  const handleGetOTP = async () => {
    if (!isEmailValid || !crn) {
      setError("Please enter a valid Gmail and try again.");
      return;
    }

    const emailExists = await checkEmailExists();
    if (emailExists) {
      alert("Email ID already exists. Please use another Email.");
      return;
    }

    axios
      .post(`https://${baseUrl}/request`, {
        object: "otp",
        action: "A",
        crn: crn,
        email: email,
      })
      .then((response) => {
        setOtpSent(true);
        setIsCounting(true);
        setOtpTimer(120);
        alert("OTP sent to your email. Please check your mail.");
      })
      .catch((error) => {
        console.error("Error sending OTP:", error);
        setError("Failed to send OTP. Please try again.");
      });
  };

  useEffect(() => {
    let timer;
    if (isCounting && otpTimer > 0) {
      timer = setInterval(() => {
        setOtpTimer((prevTime) => prevTime - 1);
      }, 1000);
    } else if (otpTimer === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [otpTimer, isCounting]);

  useEffect(() => {
    axios
      .post(`https://${baseUrl}/request`, { object: "crn", qdn: "diabrain" })
      .then((response) => {
        if (response.data.crn) {
          setCrn(response.data.crn);
        } else {
          setError("Failed to fetch CRN. Please try again later.");
        }
      })
      .catch((err) => {
        console.error("Error fetching crn:", err);
        setError("Failed to fetch CRN. Please try again later.");
      });
  }, []);

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!crn) {
      setError("CRN is missing. Signup cannot proceed.");
      return;
    }

    if (!name.trim() || !email.trim() || !password.trim() || !confirmPassword.trim() || !contact.trim() || !otp.trim()) {
      setError("All fields are required!");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    if (contact.length !== 10) {
      alert("Please enter a valid 10-digit contact number.");
      return;
    }

    try {
      const otpVerify = await axios.post(`https://${baseUrl}/request`, {
        object: "otp",
        action: "V",
        crn: crn,
        otp: otp,
        email: email,
      });

      if (otpVerify.data.status === "00") {
        const response = await axios.post(`https://${baseUrl}/request`, {
          user_id: contact.trim(),
          name: name.trim(),
          email: email.trim(),
          password: password.trim(),
          contact: contact.trim(),
          crn: crn,
          object: "users",
          action: "A",
        });

        if (response.data && response.data.status === "00") {
          alert("Account created successfully. Please login.");
          navigate("/login.html");
        } else if (response.data && response.data.status === "11") {
          alert("This contact number already exists.");
        } else {
          alert(response.data.message || "Signup failed. Please try again.");
        }
      } else if (otpVerify.data.status === "07") {
        alert("Wrong OTP, please try again.");
      } else if (otpVerify.data.status === "17") {
        alert("OTP Expired, please try again.");
      } else {
        alert("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Signup Error:", error);
      setError("An error occurred. Please try again later.");
    }
  };

  const handleBackToLogin = () => {
    navigate("/login.html");
  };

  return (
    <>
      <Header />
      <div className="login-wrapper">
        <div className="login-container">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "15px" }}>
            <button 
              className="btn btn-sm btn-danger" 
              onClick={handleBackToLogin}
              style={{ 
                display: "flex", 
                alignItems: "center", 
                padding: "5px 10px"
              }}
            >
              <span style={{ fontSize: "16px", marginRight: "5px" }}>&#8592;</span> Back
            </button>
            <h2 className="sign-title mb-0">
              <span className="text-dark">SIGN</span>
              <span className="main_title_c1">UP</span>
            </h2>
            <div style={{ width: "70px" }}></div> {/* Spacer div for alignment */}
          </div>

          {error && <p className="error-message" style={{ color: "red" }}>{error}</p>}

          <form onSubmit={handleSignup}>
            <div className="form-group">
              <label style={{ fontWeight: "bold", fontSize: "16px" }}>
                Full Name <span className="required" style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                pattern="^[A-Za-z\s]+$"
                title="Only alphabets and spaces are allowed."
                required
              />
            </div>

            <div className="form-group">
              <label style={{ fontWeight: "bold", fontSize: "16px" }}>
                Password <span className="required" style={{ color: "red" }}>*</span>
              </label>
              <input
                type="password"
                placeholder="Create a password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label style={{ fontWeight: "bold", fontSize: "16px" }}>
                Confirm Password <span className="required" style={{ color: "red" }}>*</span>
              </label>
              <input
                type="password"
                placeholder="Confirm your password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label style={{ fontWeight: "bold", fontSize: "16px" }}>
                Contact No. <span className="required" style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="Enter your contact number"
                value={contact}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setContact(value);
                  }
                }}
                maxLength="10"
                pattern="\d{10}"
                title="Enter a valid 10-digit mobile number."
                required
              />
            </div>

            <div className="form-group">
              <label style={{ fontWeight: "bold", fontSize: "16px" }}>
                Email ID <span className="required" style={{ color: "red" }}>*</span>
              </label>
              <input
                type="email"
                className="form-control me-2"
                placeholder="Enter your Gmail (Only Gmail addresses are allowed)"
                value={email}
                onChange={handleEmailChange}
                pattern="[a-zA-Z0-9._%+-]+@gmail\.com$"
                title="Only Gmail addresses are allowed"
                required
              />
            </div>

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleGetOTP}
              disabled={!isEmailValid || isCounting}
            >
              {otpSent ? `Resend OTP (${otpTimer}s)` : "Get OTP"}
            </button>

            <div className="form-group mt-3">
              <label style={{ fontWeight: "bold", fontSize: "16px" }}>
                Enter Email OTP <span className="required" style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn btn-success w-100">
              Create Account
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Signup;